// removed by extract-text-webpack-plugin
module.exports = {"container":"_1jsVB","group":"_2t5T7","button":"ptp5E","largeSpacings":"_6r7hM","separator":"_1jKyo"};


//////////////////
// WEBPACK FOOTER
// ./app/components/text-editor/text-editor-inline-toolbar.scss
// module id = 812
// module chunks = 3 4 5 6 7